import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const renderPartial = (value) => (
  <div  className="duration-timer__part">
    <div className="duration-timer__part-value">{value}</div>
  </div>
);


const renderPartialLandscape = (value, title, symbol) => (
  <div className="duration-timer__part--landcape">
    <div  className="duration-timer--landscape">
      <span className="duration-timer__value--landscape">{value}</span>
      {symbol && <span className="duration-timer__symbol--landscape">{symbol}</span>}
    </div>
    <span className="duration-timer__title--landscape">{title}</span>
  </div>
);


const DurationTimer = ({ className, duration, leadingZeros, isMobile, isMobileLandscape}) => {
  const { t } = useTranslation();
  const classes = `duration-timer ${className || ''}`;
  const [remaining, setRemaining] = useState(duration);

  useEffect(() => {
    if (Math.floor(remaining) <= 0) return;
    const handle = setInterval(() => {
      const r = setRemaining(r => r - 1);
      if (r <= 0) clearInterval(handle);
    }, 1000);
    return () => clearInterval(handle);
  }, [duration, remaining]);

  let hours = Math.floor(remaining / 3600);
  if (leadingZeros && hours < 10) hours = `0${hours}`;

  let minutes = Math.floor((remaining % 3600) / 60);
  if (leadingZeros && minutes < 10) minutes = `0${minutes}`;

  let seconds = Math.floor((remaining % 3600) % 60);
  if (leadingZeros && seconds < 10) seconds = `0${seconds}`;

  if(isMobile){
    if (duration <= 0) return (
      <div className='duration-mobile-wrapper'>
        <span className="duration-mobile">00 : 00: 00</span>
      </div>
    );
  
    return (
      <div className='duration-mobile-wrapper'>
        <span className="duration-mobile">{`${hours}:${minutes}:${seconds}`}</span>
      </div>
    );
  }

  if(!isMobile){
    if (duration <= 0) return (
      <div className={classes}>
        {renderPartial('00')}
        :
        {renderPartial('00')}
        :
        {renderPartial('00')}
      </div>
    );
  
    if(isMobileLandscape){
      return(
        <div className="duration-timer__part__wrapper--landscape">
          {renderPartialLandscape(hours, t('tournaments.hours'), ':')}
          {/* will translate 'Minutes'  */}
          {renderPartialLandscape(minutes, t('minutes'), ':')}
          {/* will translate 'Seconds'  */} 
          {renderPartialLandscape(seconds, t('seconds'))}  
        </div>
      )
    }


    return (
      <div className={classes}>
        {renderPartial(hours, t('tournaments.hours'))}
        :
        {/* will translate 'Minutes'  */}
        {renderPartial(minutes, t('minutes'))}
        :
        {/* will translate 'Seconds'  */}
        {renderPartial(seconds, t('seconds'))}
      </div>
    );
  }
}

export default  DurationTimer;